import { render, staticRenderFns } from "./ManagementManagedServicesTicketConfirmation.vue?vue&type=template&id=6c835f20&scoped=true&"
import script from "./ManagementManagedServicesTicketConfirmation.vue?vue&type=script&lang=ts&"
export * from "./ManagementManagedServicesTicketConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c835f20",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VForm,VIcon,VImg,VRow})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c835f20')) {
      api.createRecord('6c835f20', component.options)
    } else {
      api.reload('6c835f20', component.options)
    }
    module.hot.accept("./ManagementManagedServicesTicketConfirmation.vue?vue&type=template&id=6c835f20&scoped=true&", function () {
      api.rerender('6c835f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/requirement/management-managed-services/components/ManagementManagedServicesTicketConfirmation.vue"
export default component.exports